module.exports = __webpack_public_path__ + "static/media/truck-loading.6881d4be.svg";